export default __webpack_public_path__ + "hero-tablet-cc0201f4b11ac63e2e8da94e8634ea96.digested.webp";